/*
 * Announcement bar — keep emoji in full colour inside gradient text.
 *
 * Gradient mode paints text with background-clip:text and
 * -webkit-text-fill-color:transparent, which applies to EVERY glyph,
 * emoji included — they come out as gradient silhouettes.
 *
 * CSS cannot select a character, so each emoji is wrapped in its own
 * span here and the CSS resets the fill on that span.
 *
 * Only runs on spans marked .keep-emoji, so a block can opt out and
 * keep the silhouette look.
 */
(function () {
  'use strict';

  var EMOJI;
  try {
    // Regional-indicator pairs are flags (🇺🇸 = U+1F1FA U+1F1F8) and are NOT
    // Extended_Pictographic, so they need their own alternative.
    EMOJI = new RegExp(
      '(?:\\p{Regional_Indicator}\\p{Regional_Indicator}' +
        '|\\p{Extended_Pictographic}\\uFE0F?' +
        '(?:\\u200D\\p{Extended_Pictographic}\\uFE0F?)*)',
      'gu'
    );
  } catch (e) {
    return; // no Unicode property escapes — leave the text untouched
  }

  function wrapTextNode(node) {
    var text = node.nodeValue;
    if (!text) return;

    EMOJI.lastIndex = 0;
    var match,
      last = 0,
      frag = document.createDocumentFragment(),
      found = false;

    while ((match = EMOJI.exec(text)) !== null) {
      found = true;
      if (match.index > last) {
        frag.appendChild(document.createTextNode(text.slice(last, match.index)));
      }
      var span = document.createElement('span');
      span.className = 'announcement-bar--emoji';
      span.textContent = match[0];
      frag.appendChild(span);
      last = match.index + match[0].length;
    }

    if (!found) return;
    if (last < text.length) {
      frag.appendChild(document.createTextNode(text.slice(last)));
    }
    node.parentNode.replaceChild(frag, node);
  }

  function process(el) {
    if (el.dataset.emojiWrapped) return;
    el.dataset.emojiWrapped = '1';

    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var nodes = [];
    var n;
    while ((n = walker.nextNode())) nodes.push(n);
    nodes.forEach(wrapTextNode);
  }

  function run() {
    document
      .querySelectorAll('.announcement-bar--text.keep-emoji')
      .forEach(process);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // The theme editor re-renders sections without a full page load.
  document.addEventListener('shopify:section:load', run);
})();
